<!-- eslint-disable -->
<template>
  <div class="choose_rent_wrapper" :style="{ width }">
    <span class="rent_tip" v-if="list?.length === 0 && disabled"> 暂无数据 </span>
    <span class="rent_info" @click="choose" v-if="list?.length === 0 && !disabled"> 请选择{{ prefix }}</span>
    <el-tooltip
      v-if="list?.length"
      popper-class="text-item-wrapper"
      effect="dark"
      :content="String(list)"
      :placement="placement"
    >
      <span class="rent_info" @click="choose" v-if="list?.length"> {{ text }} </span>
    </el-tooltip>
    <span class="rent_tip" v-if="listLength">等 {{ listLength }} 个 {{ prefix }}</span>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'ShowText',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    prefix: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '500px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top-start',
    }
  },
  computed: {
    listLength() {
      return this.list?.length ? this.list?.length - 1 : 0;
    },
    text() {
      return this.list[0] || null;
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    choose() {
      // if (this.disabled) return;
      this.$emit('choose');
    },
  },
};
</script>
<style scoped lang="scss">
.choose_rent_wrapper {
  height: 32px;
  line-height: 32px;
  max-width: 800px;
  text-align: left;
  // display: flex;
  .rent_info {
    color: #059e84;
    cursor: pointer;
    // flex: 1;
    // white-space: nowrap;
    // word-break: break-all;
    // text-overflow: ellipsis;
    // overflow: hidden;
  }
  .rent_tip {
    color: #171717;
  }
}
</style>
<style lang="scss">
.text-item-wrapper {
  max-width: 480px !important;
}
</style>
